import axios from "../../../../../../api/axiosInstance";
import {
  FetchCampaignProductsRequest,
  FetchCampaignProductsResponse,
} from "@/modules/stochastic/features/CampaignManagement/api/fetchCampaignProducts/types";

export const fetchCampaignProducts = async (
  requestData?: FetchCampaignProductsRequest,
): Promise<FetchCampaignProductsResponse> => {
  const params: Record<string, any> = {};

  if (requestData?.page) {
    params.page = requestData.page;
  }

  if (requestData?.pageSize) {
    params.pageSize = requestData.pageSize;
  }

  if (requestData?.sortBy) {
    params.sortBy = requestData.sortBy;
  }

  if (requestData?.sortOrder) {
    params.sortOrder = requestData.sortOrder;
  }

  if (requestData?.searchTerm) {
    params.searchTerm = requestData.searchTerm;
  }

  const response = await axios.get<FetchCampaignProductsResponse>(
    "/api/private/campaign-products",
    { params },
  );
  return response.data;
};
